"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
// import Spinner from "react-bootstrap/Spinner";


var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _getUser = require("./api/getUser");

var _reactAxios = require("@dreamchimney/react-axios");

var _reactAxios2 = _interopRequireDefault(_reactAxios);

var _userContext = require("./userContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var LOCAL_STORE_JWT = "chim_jwt";


var AuthWrapper = function AuthWrapper(props) {
  var jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useUser = (0, _userContext.useUser)(),
      userState = _useUser.state,
      dispatch = _useUser.dispatch;

  var loadDataOnlyOnce = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _getUser.userValidate)(_reactAxios2.default, _getUser.urlUserValidate, { jwt: jwt }).then(function (_ref2) {
                var data = _ref2.data;

                // console.log("*******Auth urlUserValidate:", data);
                if (!data.success) {
                  // console.log("*******Auth urlUserValidate: success FALSE");
                  // @TODO this makes the jwt was not set or invalid
                  // should redirect user to reauth page
                  throw new Error("User not validated");
                }
                // console.log("data:", data);
                return data;
              }).then(function (_ref3) {
                var isChim = _ref3.isChim,
                    user = _ref3.user;

                // console.log("*******Auth isChim:", isChim);
                // console.log("*******Auth loadDataOnlyOnce user:", user);
                if (isChim === false) {
                  dispatch({ type: "user_login", payload: { user: user } });
                } else {
                  dispatch({ type: "login", payload: { user: user } });
                }
                return;
                // return getUser(axios, urlGetUser, { chimdir: user.dir }).then(({ data }) => {
                //   console.log("*******Auth getUser:", data);
                //   // {
                //   // success: true,
                //   // chim: {chim_dir: "ryan", chim_id: "31", full_name: "Ryan"}
                //   // }
                //   return new Promise(function (resolve, reject) {
                //     if (data.success) {
                //       dispatch({ type: "login", payload: { chim: data.chim } });
                //     } else {
                //       console.log("*******Auth getUser: fail");
                //       dispatch({ type: "fail", payload: {} });
                //     }
                //     resolve();
                //   });
                // });
              }).then(function () {
                return setLoading(false);
              }).catch(function (e) {
                console.log("*******Auth urlUserValidate: axios: FALSE");
                setLoading(false);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function loadDataOnlyOnce() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (jwt) {
      loadDataOnlyOnce();
    } else {
      setLoading(false);
      dispatch({ type: "anonymous", payload: {} });
    }
  }, []);

  if (loading) {
    // return <Spinner animation="border" style={{ display: "block", margin: "10px auto" }} variant="dark" />;
    return _react2.default.createElement("div", null);
  }
  return _react2.default.createElement(
    "div",
    null,
    props.children
  );
};

exports.default = AuthWrapper;